// extracted by mini-css-extract-plugin
export default {"root":"CampaignContent_root__k6cOM"};